import React, { useState } from 'react';
import { ClockIcon, MapPinIcon, MenuIcon, XIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface HeaderProps {
  currentPage: string;
  onNavigate: (page: string) => void;
}
const navLinks = [{
  label: 'Home',
  page: 'home'
}, {
  label: 'About',
  page: 'about'
}, {
  label: 'Services',
  page: 'services'
}, {
  label: 'Specials',
  page: 'specials'
}, {
  label: 'Careers',
  page: 'careers'
}, {
  label: 'Contact',
  page: 'contact'
}];
export function Header({
  currentPage,
  onNavigate
}: HeaderProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <header className="sticky top-0 z-50 w-full flex flex-col shadow-sm" data-id="element-119">
      {/* Top Info Bar */}
      <div className="w-full bg-secondary text-white py-2 px-4 sm:px-6 lg:px-8 text-sm sm:text-base" data-id="element-120">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row justify-between items-center gap-2 text-center sm:text-left" data-id="element-121">
          <div className="flex items-center gap-2" data-id="element-122">
            <ClockIcon className="w-4 h-4 text-primary shrink-0" data-id="element-123" />
            <span className="font-bold" data-id="element-124">OUR HOURS</span>
            <span className="text-white/70" data-id="element-125">Available 24/7</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-126">
            <MapPinIcon className="w-4 h-4 text-primary shrink-0" data-id="element-127" />
            <span className="text-white/70" data-id="element-128">
              Maryland, DC, and Virginia Towing & Roadside Assistance
            </span>
          </div>
        </div>
      </div>

      {/* Main Header */}
      <div className="w-full bg-white/90 backdrop-blur-md border-b border-gray-100" data-id="element-129">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between" data-id="element-130">
          <button onClick={() => onNavigate('home')} className="flex items-center cursor-pointer shrink-0" data-id="element-131">
            <img src="https://cdn.magicpatterns.com/uploads/9X9TPfvH9ot6QAJ7Jk3ZEk/ChatGPT_Image_Mar_9,_2026,_12_42_44_PM.png" alt="Uzoka Tow Truck Service" className="h-14 w-auto object-contain" data-id="element-132" />
          </button>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-6" data-id="element-133">
            {navLinks.map(link => <button key={link.page} onClick={() => onNavigate(link.page)} className={`font-medium text-sm transition-colors ${currentPage === link.page ? 'text-primary font-bold' : 'text-secondary hover:text-primary'}`} data-id="element-134">
                {link.label}
              </button>)}
          </nav>

          <div className="flex items-center gap-4 shrink-0" data-id="element-135">
            <button className="hidden sm:block bg-primary hover:bg-red-800 text-white font-bold py-2 px-6 rounded-full transition-colors duration-200 shadow-md" data-id="element-136">
              CALL DISPATCH
            </button>
            <button className="lg:hidden p-2 text-secondary hover:text-primary transition-colors" onClick={() => setIsOpen(!isOpen)} aria-label="Toggle menu" data-id="element-137">
              {isOpen ? <XIcon className="w-6 h-6" data-id="element-138" /> : <MenuIcon className="w-6 h-6" data-id="element-139" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Nav Dropdown */}
      <AnimatePresence data-id="element-140">
        {isOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="lg:hidden bg-white border-b border-gray-100 overflow-hidden" data-id="element-141">
            <nav className="flex flex-col px-4 py-4 gap-4 max-w-7xl mx-auto" data-id="element-142">
              {navLinks.map(link => <button key={link.page} onClick={() => {
            onNavigate(link.page);
            setIsOpen(false);
          }} className={`text-left font-medium text-base transition-colors ${currentPage === link.page ? 'text-primary font-bold' : 'text-secondary hover:text-primary'}`} data-id="element-143">
                  {link.label}
                </button>)}
              <button className="sm:hidden w-full bg-primary hover:bg-red-800 text-white font-bold py-3 px-6 rounded-full transition-colors duration-200 shadow-md mt-2" data-id="element-144">
                CALL DISPATCH
              </button>
            </nav>
          </motion.div>}
      </AnimatePresence>
    </header>;
}